export interface SassWorker {
  compile: (scss: string, options: SassOptions, callback: (result: any) => void) => CompileResult;
}

export interface CompileResult {

  // status 0 means everything is ok,
  // any other value means an error occurred
  status: number
  // the compiled CSS
  text?: string
  // the SourceMap for this compilation
  // "map": {
  //   "version": 3,
  //   "sourceRoot": "root",
  //   "file": "stdout",
  //   "sources": [
  //     "stdin"
  //   ],
  //   "sourcesContent": [
  //     "$someVar: 123px; .some-selector { width: $someVar; }"
  //   ],
  //   "mappings": "AAAiB,cAAc,CAAC;EAAE,KAAK,EAA7B,KAAK,GAAkB",
  //   "names": []
  // },
  // the files that were used during the compilation
  files?: string[]

  // the file the problem occurred in
  file?: string;
  // the line the problem occurred on
  line?: number,
  // the character on the line the problem started with
  column?: number,
  // the problem description
  message?: string;
  // human readable formatting of the error
  formatted?: string
}

export interface SassOptions {
  /** Format output: nested, expanded, compact, compressed */
  style: SassStyle;

  /**
   * Decimal point precision for outputting fractional numbers
   * (-1 will use the libsass default, which currently is 5)
   */
  precision?: number;

  /** If you want inline source comments */
  comments?: boolean;

  /** String to be used for indentation */
  indent?: string;

  /** String to be used to for line feeds */
  linefeed?: string;

  /**  Treat source_string as SASS (as opposed to SCSS) */
  indentedSyntax?: boolean;

  /** Embed included contents in maps */
  sourceMapContents?: boolean;

  /** Embed sourceMappingUrl as data uri */
  sourceMapEmbed?: boolean;
}

export enum SassStyle {
  nested,
  expanded,
  compact,
  compressed
};